import React from 'react';

export default function NoQuestionArrowSVG() {
return (<svg xmlns="http://www.w3.org/2000/svg" width="99.619" height="100.678" viewBox="0 0 99.619 100.678">
<path id="Path_244" data-name="Path 244" d="M25.61,11.513C26.326,7.643,26.989,4.054,27.737,0L0,19.164l28.871,17.45L26.089,25.473A64.409,64.409,0,0,1,81.952,81.022c1.993-10.516-.943-30.62-13.8-46.171C57.125,21.517,42.948,13.878,25.61,11.513Z" transform="matrix(0.259, 0.966, -0.966, 0.259, 78.262, 0)" fill="#f3f3f3"/>
</svg>
)
}
